import { render, staticRenderFns } from "./FamilyDisplay.vue?vue&type=template&id=b90e4b4c&scoped=true"
import script from "./FamilyDisplay.vue?vue&type=script&lang=js"
export * from "./FamilyDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90e4b4c",
  null
  
)

export default component.exports